<template>
  <div class="page-disease-desc">
    <div class="content">
      <div class="card">
        <div class="title">
          <span>病情描述</span>
          <van-button v-if="showAddIllnessBtn" type="primary" :border="false" plain @click="addIllnessPopupVisible=true">添加疾病</van-button>
        </div>
        <div class="tag-list" v-if="requirementId">
          <span class="tag" :class="{ selected: item.selected }" v-for="(item, index) in diseaseDesc" :key="index" @click="handleTagTrigger(item)">{{ item.value }}</span>
        </div>
        <van-field v-else type="textarea" :maxlength="150" show-word-limit v-model="diseaseStr" placeholder="请描述您的疾病或症状"></van-field>
        <van-popup v-model="addIllnessPopupVisible" position="bottom" closeable get-container="body">
          <div class="popup-title">已确诊疾病</div>
          <van-field
            v-model="editedIllness"
            placeholder="请输入已确证疾病，最多10个字"
            :maxlength="10"
          />
          <div class="popup-bottom">
            <van-button type="primary" plain block @click="addIllnessPopupVisible=false" style="margin-right: 12px; border: 1px solid #D9D9D9; color: #262626;">取消</van-button>
            <van-button type="primary" block @click="handleIllnessAdd">确认</van-button>
          </div>
        </van-popup>
      </div>
      <div class="card">
        <div class="title">上传检查报告或患处照片（选填）</div>
        <span class="hint">照片仅医生可见</span>
        <UploadImage :limit="4" @handleImageChange="handleImageChange" />
      </div>
      <div class="card">
        <div class="title">疾病史</div>
        <div class="flex-line">
          <span class="label">过敏史：</span>
          <van-radio-group v-model="allergic" direction="horizontal">
            <van-radio name="无">无</van-radio>
            <van-radio name="有">有</van-radio>
          </van-radio-group>
        </div>
        <div class="flex-line">
          <span class="label">肝/肾功能：</span>
          <van-radio-group v-model="liverKidney" direction="horizontal">
            <van-radio name="正常">正常</van-radio>
            <van-radio name="异常">异常</van-radio>
          </van-radio-group>
        </div>
      </div>
    </div>
    <div class="bottom">
      <van-button type="primary" block @click="submit">下一步</van-button>
    </div>
  </div>
</template>

<script>
import UploadImage from './components/UploadImage';
import { ZYToast } from '@zyf2e/adapt';

export default {
  name: 'DiseaseDesc',
  data() {
    return {
      doctorId: '',
      requirementId: '',
      diseaseDesc: [],
      imageList: [],
      allergic: '无',
      liverKidney: '正常',
      addIllnessPopupVisible: false,
      editedIllness: '',
      diseaseStr: ''
    };
  },
  computed: {
    showAddIllnessBtn() {
      return this.requirementId && this.diseaseDesc.filter(v => v.custom).length < 5;
    }
  },
  mounted() {
    const { doctorId, requirementId, diseaseDesc } = this.$route.query;
    this.doctorId = doctorId;
    this.requirementId = requirementId;
    if (requirementId) {
      const diseaseDescArr = JSON.parse(diseaseDesc);
      if (Array.isArray(diseaseDescArr)) {
        this.diseaseDesc = diseaseDescArr.map((str) => ({ selected: false, value: str }))
      }
    }
  },
  components: {
    UploadImage
  },
  methods: {
    handleImageChange(list) {
      this.imageList = list || [];
    },
    handleIllnessAdd() {
      if (this.editedIllness) {
        this.diseaseDesc.push({
          custom: true,
          selected: true,
          value: this.editedIllness
        });
        this.addIllnessPopupVisible = false;
        this.editedIllness = '';
      } else {
        this.$toast('请输入已确诊疾病');
      }
    },
    handleTagTrigger(item) {
      item.selected = !item.selected;
    },
    submit() {
      if (this.requirementId) {
        const diseaseArr = this.diseaseDesc.filter((item) => item.selected).map(item => item.value);
        if (diseaseArr.length === 0) {
          this.$toast('请输入病情描述');
          return;
        }
        this._submit(diseaseArr);
      } else {
        if (!this.diseaseStr) {
          this.$toast('请输入病情描述');
          return;
        }
        this._submit([this.diseaseStr]);
      }
    },
    async _submit(diseaseDesc) {
      try {
        ZYToast.open();
        const data = await this.$fetch.saveDiseaseDesc({
          doctorId: this.doctorId,
          requirementId: this.requirementId,
          diseaseDesc,
          diseaseImg: this.imageList,
          diseaseHistory: {
            allergic: this.allergic,
            liverKidney: this.liverKidney
          }
        })
        if (data.jumpPage == 1) {
          window.wx.closeWindow();
        } else if (data.jumpPage == 3) {
          this.$router.push({
            path: '/pay-advisory',
            query: {
              doctorId: this.doctorId,
              doctorName: data.advisoryPayInfo?.doctorName,
              doctorAvatar: data.advisoryPayInfo?.doctorAvatar,
              price: this.formatPrice(data.advisoryPayInfo?.price),
              requirementId: this.requirementId,
              expireTimestamp: data.advisoryPayInfo?.expireTimestamp || '',
              advisoryId: data.advisoryPayInfo?.advisoryId || '',
              payAgain: data.advisoryPayInfo?.payAgain,
              now: Date.now()
            }
          });
        }
      } finally {
        ZYToast.close();
      }
    },
    formatPrice(price) {
      if (price && typeof price === 'number') {
        return (price / 100).toFixed(2);
      } else {
        return '';
      }
    },
  }
};
</script>

<style lang="less" scoped>
.page-disease-desc {
  height: 100vh;
  width: 100vw;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .content {
    padding-top: 12px;
    .card {
      margin: 0 12px 8px 12px;
      background: #FFFFFF;
      border-radius: 8px;
      padding: 0 12px 12px;
      .title {
        height: 48px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #262626;
        line-height: 16px;
        .van-button {
          padding-left: 0;
          padding-right: 0;
        }
      }
      .van-cell {
        padding: 0;
      }
      .hint {
        display: block;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #595959;
        line-height: 21px;
        margin-bottom: 12px;
      }
      .flex-line {
        display: flex;
        align-items: center;
        margin-bottom: 20px;
        margin-top: 8px;
        .label {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #262626;
          line-height: 14px;
        }
      }
      .tag-list {
        min-height: 64px;
        display: flex;
        flex-wrap: wrap;
        align-items: flex-start;
        .tag {
          padding: 6px 16px;
          background: #EBF8FF;
          border-radius: 12px;
          font-size: 12px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #1E8DFF;
          line-height: 12px;
          margin-right: 16px;
          margin-bottom: 8px;
          &.selected {
            background: #1E8DFF;
            color: #FFFFFF;
          }
        }
      }
    }
  }
  .bottom {
    padding: 8px 16px;
    background: #FFFFFF;
  }
}
.popup-title {
  height: 50px;
  width: 100%;
  text-align: center;
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #262626;
  line-height: 50px;
}
.popup-bottom {
  margin-top: 42px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 16px 34px;
}
</style>
